import React, { useEffect, useState } from 'react';
import { AsButton, IconDelete } from '@adserve/adserve-react-components';
import AsDropDown from '../../generic/AsAdvancedDropdown/AsDropdown';
const AddingRow = ({
    campaign,
    readOnly,
    layoutBoxStyle,
    currentTypes,
    addingTypes,
    currentStations,
    currentWeeks,
    updateValues,
    currentDayparts,
    descriptionStyle,
    currentDaysOfWeek,
    canAdd,
    AddExclusion
}) => {
    const exclusionTitleStyle = {
        color: '#414141',
        fontSize: 15,
        fontWeight: 500,
        paddingBottom: 7,
        paddingTop: 12.5
    };
    const disabled = campaign.copyTypes.length === 0 || readOnly;
    return (
        <div
            style={{
                display: 'flex',
                width: '100%'
            }}
        >
            <div style={{ width: '90%', display: 'flex' }}>
                <div
                    key={'dd0'}
                    style={{
                        ...layoutBoxStyle,
                        border: '0px',
                        width: 40
                    }}
                />
                <div
                    key={'dd1'}
                    style={{
                        ...layoutBoxStyle,
                        width: 'calc(35.02% - 40px)'
                    }}
                >
                    <span style={exclusionTitleStyle}>{window.translate('Copy Type')}</span>

                    {currentTypes.length > 1 ? (
                        <AsDropDown
                            values={currentTypes}
                            selectedValues={addingTypes.copyTypes}
                            onChange={updateValues}
                            indexKey='copyTypes'
                            width='95%'
                            applyRequired={false}
                            disabled={disabled || readOnly}
                        ></AsDropDown>
                    ) : (
                        <div style={descriptionStyle}>
                            <span
                                style={{
                                    paddingLeft: 10,
                                    color: disabled ? '#919191' : '#414141'
                                }}
                            >
                                {currentTypes[1]?.name}
                            </span>
                        </div>
                    )}
                </div>
                <div
                    key='dd2'
                    style={{
                        ...layoutBoxStyle,
                        width: '18.958%'
                    }}
                >
                    <span style={exclusionTitleStyle}>{window.translate('Station')}</span>
                    <AsDropDown
                        values={currentStations}
                        selectedValues={addingTypes.stations}
                        onChange={updateValues}
                        indexKey='stations'
                        width='92%'
                        applyRequired={false}
                        disabled={disabled || readOnly}
                    ></AsDropDown>
                </div>
                <div
                    key='dd4'
                    style={{
                        ...layoutBoxStyle,
                        width: '17.58%'
                    }}
                >
                    <span style={exclusionTitleStyle}>{window.translate('Week')}</span>
                    {currentWeeks.length === 0 ? (
                        <div style={descriptionStyle}>
                            <span
                                style={{
                                    paddingLeft: 10,
                                    color: disabled ? '#919191' : '#414141'
                                }}
                            >
                                {window.translate('Week')} 1
                            </span>
                        </div>
                    ) : (
                        <AsDropDown
                            applyRequired={false}
                            values={currentWeeks}
                            selectedValues={addingTypes.weeks}
                            onChange={updateValues}
                            indexKey='weeks'
                            disabled={disabled || currentWeeks.length === 0 || readOnly}
                            width='92%'
                        ></AsDropDown>
                    )}
                </div>
                <div
                    key='dd3'
                    style={{
                        ...layoutBoxStyle,
                        width: '14.833%'
                    }}
                >
                    <span style={exclusionTitleStyle}>{window.translate('Day')}</span>
                    <AsDropDown
                        applyRequired={false}
                        values={currentDaysOfWeek}
                        selectedValues={addingTypes.daysOfWeek}
                        onChange={updateValues}
                        indexKey='daysOfWeek'
                        width='92%'
                        disabled={disabled || readOnly}
                    ></AsDropDown>
                </div>
                <div
                    key='dd5'
                    style={{
                        ...layoutBoxStyle,
                        width: '17.583%'
                    }}
                >
                    <span style={exclusionTitleStyle}>{window.translate('Daypart')}</span>
                    <AsDropDown
                        applyRequired={false}
                        values={currentDayparts}
                        selectedValues={addingTypes.dayParts}
                        onChange={updateValues}
                        indexKey='dayParts'
                        width='92%'
                        disabled={disabled || readOnly}
                    ></AsDropDown>
                </div>
            </div>
            <div>
                <AsButton
                    disabled={!canAdd || readOnly}
                    style={{
                        width: 120,
                        height: 40,
                        marginLeft: 20,
                        marginTop: 30,
                        fontSize: 15,
                        fontWeight: 'bold'
                    }}
                    handleClick={AddExclusion}
                >
                    {window.translate('Add Exclusion')}
                </AsButton>
            </div>
        </div>
    );
};
export default AddingRow;
